module.exports = __webpack_public_path__ + "assets/normal/images/Empty_1.5bf7e337.png";